@if (forms) {
  <section
    class="astral-multi-file-upload"
    [class.astral-multi-file-upload--content-width]="contentWidth"
    app-drag-drop
    (fileDropped)="onFileChange($event)"
  >
    <input
      #uploadFile
      class="astral-multi-file-upload__native-input"
      type="file"
      data-testid="file-upload-input"
      [disabled]="readonly"
      [attr.accept]="allowedMimeTypes?.join(',') || null"
      [multiple]="maxFiles > 1"
      (change)="onFileInputChange($event.target.files)"
    />

    <div class="astral-multi-file-upload__grid">
      @for (form of $any(forms.controls); track form) {
        <article class="astral-multi-file-upload__item astral-stack-s">
          <div class="astral-multi-file-upload__card astral-section-surface">
            <div class="astral-multi-file-upload__preview-row">
              <button
                class="astral-multi-file-upload__preview"
                type="button"
                [attr.aria-label]="form.controls['title'].value"
                (click)="previewFile(form)"
              >
                <div class="astral-multi-file-upload__file-icon" [ngClass]="getClass(form.controls['mimeType'].value)"></div>
                @if (showImage(form.controls['mimeType'].value)) {
                  <img [src]="form.controls['src'].value" [alt]="form.controls['title'].value" />
                }
              </button>

              @if (!readonly) {
                <button
                  class="astral-multi-file-upload__delete"
                  type="button"
                  [attr.aria-label]="'DELETE_BTN' | translate"
                  [title]="'DELETE_BTN' | translate"
                  (click)="delete(form)"
                >
                  <i [class]="clearIconClass" aria-hidden="true"></i>
                </button>
              }
            </div>
          </div>

          <astral-input [control]="form.controls['title']" [disabled]="readonly"></astral-input>
        </article>
      }

      @if (fileCount < maxFiles && !readonly) {
        <section class="astral-multi-file-upload__add astral-section-surface astral-stack-s">
          <span>{{ 'DOCUMENT.DRAG_DROP_FILE_HERE' | translate }}</span>
          <i class="astral-multi-file-upload__add-icon" [ngClass]="uploadIconClass" aria-hidden="true"></i>
          <span class="astral-multi-file-upload__or">{{ 'COMMON.OR' | translate }}</span>
          <astral-button variant="primary" size="small" type="button" icon="upload" [label]="text | translate" (click)="openFileDialog()"></astral-button>
        </section>
      }
    </div>
  </section>
}
